@import 'src/global/variables';
@import 'src/global/mixins';
@import '../../global/accessibility.css';

@keyframes flickerAnimation {
	0%   { opacity:1; }
	50%  { opacity:0.6; }
	100% { opacity:1; }
}

* {
  box-sizing: border-box;
}

.summary {
  width: 100%;
  color: $color-warm-grey-90;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5em 1em;

  background-color: $color-white;

  @include nj-mobile-no-padding;

  @media #{$screen-max-sm} {
    width: auto;
  }

  @media #{$screen-min-sm} {
    font-size: 1.125em;
  }

  @media #{$screen-min-lg} {
    flex-direction: row;
    justify-content: space-between;
  }

  >div {
    padding: 0 0.5rem;
    width: 100%;
  }

  button {
    @include nj-button;
    flex-shrink: 0;
    fill: currentColor;

    @media #{$screen-min-lg} {
      margin-left: 24px
    }

    @media #{$screen-max-sm} {
      width: 100%;
      justify-content: center;
    }
  }

  &.animate button {
    animation: flickerAnimation 2s infinite;
  }
}

.summary__item {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0.75em;

  @media #{$screen-min-lg} {
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.summary__item--not-selected {
  // cursor: pointer;

  edit-icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;

    svg {
      fill: $color-nightjet;
    }
  }

  .summary__backlink {
    color: $tint-oebb;
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
      color: #c90025;
    }
  }
}

.summary__term {
  margin: 0 0 0.5rem;
  font-weight: 700;
  display: block;
  color: black;
}

check-icon {
  display: inline-block;
  width: 30px;
  vertical-align: middle;
  color: $color-nightjet;
}

.summary__date {
  margin-bottom: 0.25rem;
  font-weight: bold;
  display: inline-block;
  margin-left: 0;
}

.summary__times {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-left: 30px;

  nj-train-icon {

    margin-right: 6px;
  }
}


.summary__connection {
  align-items: center;
  display: grid;
  width: 100%;

  grid-template-columns: 20px 1fr;
  grid-template-rows: 1fr;
  gap: 1rem;
  
  check-icon{
    margin-top:0.5rem;
    align-self:flex-start;
  }

  &__item {
    margin-top:0.5rem;
    align-self:flex-start;
    display: flex;
    flex-direction: column;

    &__date {
      font-weight: bold;
    }
  }

  nj-train-info {
    grid-area: 2 / 1 / 3 / 5;

    @media #{$screen-min-md} {
      grid-area: 1 / 3 / 2 / 4;
    }
  }
}

.train__traveling--mobile-line {
  width: 100%;
  height: 1px;
  border-bottom: 1px dotted $color-cool-grey-40;
  grid-area: 1 / 3 / 2 / 4;

  @media #{$screen-min-md} {
      display: none;
  }
}